import axios from './axios';

const KdsStationService = {
    getStationData: async (restaurant_id) => {
        try {
            const response = await axios.get(`/kds-stations`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    saveStationData: async (data) => {
        try {
            const response = await axios.post(`/kds-stations`, data);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    updateStationData: async (menuItem,id) => {
        try {
            const response = await axios.put(`/kds-stations/${id}`, menuItem);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    deleteStationData: async(id) => {
        try {
            const response = await axios.delete(`/kds-stations/${id}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
};

export default KdsStationService;